// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"99dc0865","297":"30a64707","315":"e497bfe0","360":"7fb5801b","456":"2ee49c06","590":"441415cb","632":"d7058a7c","900":"be4a23cc"}[chunkId] + ".chunk.js";
};